import { useRoute } from 'vue-router';
import { AppCoreEnums } from 'src/core/shared/enums';
import { Pagination } from '../../../stores/core/models';
import useRouterUtils from '../../router-utils/route-utils';
import updatePaginationStateData from '../use-pagination-utils';
import { IRouteMeta, ResolveParams, ResolveResult } from '../../models/routing';

export default () => {
  const route = useRoute();
  const { getRouteWithContainer, getRouteWithInnerContainer } = useRouterUtils();

  const runContainerRouteResolve = (
    pagination: Pagination | undefined,
    containerType: AppCoreEnums.ContainerType
  ): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
      const routeWithContainer = getRouteWithContainer(route, containerType) || getRouteWithInnerContainer(route, containerType);
      const routeMeta = routeWithContainer?.meta as IRouteMeta;

      if (pagination) {
        pagination.skipActualPage = containerType === AppCoreEnums.ContainerType.CollapsibleTableContainer;
      }

      const resolveParams = new ResolveParams();
      resolveParams.pagination = pagination;
      resolveParams.params = route.params;
      resolveParams.useStoreData = true;
      resolveParams.containerType = containerType;
      resolveParams.routeName = routeWithContainer?.name?.toString() || '';

      routeMeta
        .resolve(resolveParams)
        .then((actionResults: ResolveResult | ResolveResult[]) => {
          const results = Array.isArray(actionResults) ? actionResults : [actionResults];
          const actionResult = results.find((x) => !!x);
          if (actionResult && actionResult.pagination && actionResult.routeName)
            updatePaginationStateData(actionResult.pagination, containerType);

          resolve();
        })
        .catch(() => reject);
    });
  };

  return {
    runContainerRouteResolve,
  };
};
